import React from 'react';
import { motion } from 'framer-motion';

const LeftToRight = ({ children, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.2, delay: index * 0.1 }}
    >
      {children}
    </motion.div>
  );
};

export default LeftToRight;
